import ListView from "./ListView/ListView";

const HistorySpb = () => <p>HistorySpb</p>;

HistorySpb.ListView = ListView;
export default HistorySpb;
